import { useOrderMovements } from '@api/useOrderMovements'
import { useCanViewEbols } from './Hooks/useCanViewEbols'
import { GraviButton, Texto } from '@gravitate-js/excalibrr'
import { FileOutlined } from '@ant-design/icons'
import { useEbolMatchingContext } from './EbolMatchingContext'

export const UnrankedEbolButton = () => {
  const { viewAll } = useEbolMatchingContext()
  const { useUnmatchedEbols } = useOrderMovements()
  const { data, isPending } = useUnmatchedEbols()
  const canView = useCanViewEbols()
  if (!canView) return

  let title = 'eBOLs Unmatched'
  if (data?.length) {
    title += ` (${data.length})`
  }

  return (
    <GraviButton color='primary' title='test' onClick={viewAll} loading={isPending} icon={<FileOutlined />}>
      <Texto weight='bold' appearance='white'>
        {title}
      </Texto>
    </GraviButton>
  )
}
